const getMLink = (url = '') => {
    const iosLink = `hbrb://hbappapi.hebrb.cn?url=${encodeURIComponent(url)}`;
    const androidLink = `hbrb://hbappapi.hebrb.cn?url=${url}`;
	const androidTecentLink = `hbrb://hbappapi.hebrb.cn?url=${encodeURIComponent(url)}`;
    const harmonyLink = `hbrb://hbappapi.hebrb.cn?url=${url}`;
    const harmonyLinkWx = `hbrb://hbappapi.hebrb.cn?url=${encodeURIComponent(url)}`;
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isAndroid = userAgent.match(/android/gi);
    const isIos = userAgent.match(/iphone|ipod|ipad/gi);
    const isQQ = userAgent.match(/QQ/gi);
    // eslint-disable-next-line camelcase
    const isIos13_1 = userAgent.match(/iPhone OS 13_1/gi);
    const isHarmonyOS = userAgent.match(/openharmony/gi);
    const isWeixin = userAgent.match(/wechat/gi) || userAgent.match(/MicroMessenger/gi);
    let openLink = `https://hbxw.hebnews.cn/d`;
    const iosyybLink = `https://a.app.qq.com/o/simple.jsp?pkgname=com.bravogo.hb.sjz.hbrb.News&ios_scheme=${encodeURIComponent(
        iosLink
    )}`;
    const androidyybLink = `https://a.app.qq.com/o/simple.jsp?pkgname=com.bravogo.hb.sjz.hbrb.News&android_schema=${encodeURIComponent(
        androidTecentLink
    )}`;
    const iosUniversalLink = `https://hbappapi.hebrb.cn/app/?url=${encodeURIComponent(url)}`;
    const harmonyyybLink = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bravogo.hb.sjz.hbrb.News&harmony_schema='+encodeURIComponent(harmonyLinkWx);
    let downloadLink = iosyybLink;
    if (isIos) {
        // IOS13.1不识别universal link
        // eslint-disable-next-line camelcase
        if (isIos13_1) {
            if (isWeixin) {
                openLink = iosyybLink;
            } else {
                openLink = iosLink;
            }
        } else if (isQQ) {
            openLink = iosLink;
        } else {
            openLink = iosUniversalLink;
        }
    } else if (isAndroid) {
        if (isWeixin) {
            openLink = androidyybLink;
        } else {
            openLink = androidLink;
        }
        downloadLink = androidyybLink;
    } else if(isHarmonyOS){
        if (isWeixin) {
        openLink = harmonyyybLink;
        } else {
        openLink = harmonyLink;
        }
        downloadLink = harmonyyybLink;    
    }
    return [openLink, downloadLink, iosLink, androidLink, iosUniversalLink];
}

function toMLink(url = '') {
    const [openLink, downloadLink, iosUniversalLink] = getMLink(url);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = openLink;
    document.body.appendChild(a);
    // eslint-disable-next-line no-undef
    const ev = new MouseEvent('click');
    a.dispatchEvent(ev);

    const now = Date.now();
    if (openLink === iosUniversalLink) {
        return;
    }
    const o = setTimeout(() => {
        if (document.hidden || document.webkitHidden) {
            clearTimeout(o);
        } else if (Date.now() - now > 3503) {
            clearTimeout(o);
        } else {
            window.location.href = downloadLink;
        }
    }, 3000);
}

function isHbrb() {
    return /(hbxw)/i.test(navigator.userAgent);
}

export default {toMLink, isHbrb}
